import { merge } from 'lodash';
import { resolvers as SetAnnotationStateResolvers } from '../client-schema/annotations/Mutation.setAnnotationState.resolver';
import { resolvers as AddMediaStateResolvers } from '../client-schema/media-state/Mutation.addMediaState.resolver';
import { resolvers as SetMediaStateResolvers } from '../client-schema/media-state/Mutation.setMediaState.resolver';
import { resolvers as RemoveUploaderConfigResolvers } from '../client-schema/transfers/Mutation.RemoveUploaderConfig.resolver';
import { resolvers as SetUploaderConfigResolvers } from '../client-schema/transfers/Mutation.SetUploaderConfig.resolver';
import type { Resolvers } from '../generated';
import { resolvers as CollectionFieldResolvers } from './features/assets-panel/collections/types/CollectionField.resolver';
import { resolvers as MetadataFilterResolvers } from './features/assets-panel/collections/types/MetadataFilter.resolver';
import { resolvers as MetadataGroupByResolvers } from './features/assets-panel/collections/types/MetadataGroupBy.resolver';
import { resolvers as MetadataSortByResolvers } from './features/assets-panel/collections/types/MetadataSortBy.resolver';
import { resolvers as ProjectResolvers } from './features/projects/Project.resolver';
import { resolvers as AddSyncSessionResolvers } from './features/sync-session/mutations/AddSyncSession.resolver';
import { resolvers as RemoveSyncSessionResolvers } from './features/sync-session/mutations/RemoveSyncSession.resolver';
import { resolvers as SetSyncSessionResolvers } from './features/sync-session/mutations/SetSyncSession.resolver';
import { resolvers as AddUndoCommandResolvers } from './features/undo-redo-demo/mutations/AddUndoCommand.resolver';
import { resolvers as ExecuteRedoCommandResolvers } from './features/undo-redo-demo/mutations/ExecuteRedoCommand.resolver';
import { resolvers as ExecuteUndoCommandResolvers } from './features/undo-redo-demo/mutations/ExecuteUndoCommand.resolver';
import { resolvers as SetUserPrefsResolvers } from './features/user-prefs/mutations/SetUserPrefs.resolver';
import { resolvers as scalarsResolvers } from './shared/scalars.resolver';

export const resolvers: Resolvers = merge(
  AddMediaStateResolvers,
  AddSyncSessionResolvers,
  AddUndoCommandResolvers,
  CollectionFieldResolvers,
  ExecuteRedoCommandResolvers,
  ExecuteUndoCommandResolvers,
  MetadataFilterResolvers,
  MetadataGroupByResolvers,
  MetadataSortByResolvers,
  ProjectResolvers,
  RemoveSyncSessionResolvers,
  RemoveUploaderConfigResolvers,
  scalarsResolvers,
  SetAnnotationStateResolvers,
  SetMediaStateResolvers,
  SetSyncSessionResolvers,
  SetUploaderConfigResolvers,
  SetUserPrefsResolvers
);
